export default {
  "content": "<g clip-path=\"url(#clip0_4034_13989)\" stroke=\"#310F0F\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6.6 16.714a6.667 6.667 0 109.428-9.428A6.667 6.667 0 006.6 16.714z\"/><path d=\"M11.314 15.772s.236-1.65-.943-2.829C9.192 11.765 7.543 12 7.543 12M14.142 12l.005.005M11.314 9.172l.004.005\"/></g><defs><clipPath id=\"clip0_4034_13989\"><path fill=\"#fff\" transform=\"rotate(45 4.828 14)\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "23",
    "height": "24",
    "viewBox": "0 0 23 24",
    "fill": "none"
  }
};